"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

var _utils = require("../helpers/utils");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var selectors = {
  control: '[js-accordion="control"]',
  tabs: '[js-tabs="control"]'
};

var _default = function _default() {
  var nodeSelectors = {
    controls: _toConsumableArray(document.querySelectorAll(selectors.control)),
    tabs: _toConsumableArray(document.querySelectorAll(selectors.tabs))
  };

  function removeSiblingTabClasses(item) {
    var parent = _toConsumableArray(item.parentNode.childNodes);

    parent.forEach(function (child) {
      if (child !== item && child.nodeType === 1) {
        child.classList.remove('active');
      }
    });
  }

  function setEventListeners() {
    Frame.EventBus.listen('Accordion:Toggle', function (event) {
      var item = nodeSelectors.tabs[event];
      removeSiblingTabClasses(item);
      toggleElement(item);
    });
  }

  function setClickEvents() {
    nodeSelectors.tabs.forEach(function (item, index) {
      (0, _utils.on)('click', item, function (event) {
        return onItemClick(event, item, index);
      });
    });
  }

  function onItemClick(event, item, index) {
    event.preventDefault();
    triggerAccordionClick(index);
  }

  function toggleElement(item) {
    item.classList.toggle('active');
  }

  function triggerAccordionClick(index) {
    nodeSelectors.controls[index].click();
  }

  function init() {
    setClickEvents();
    setEventListeners();
  }

  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;